import { useMemo } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { apiTestingTranslator } from '../../translations/apiTesting';
import { apiTestingFeedback } from './apiTestingFeedback';

export function useApiTestingLanguage() {
  const { language } = useLanguage();
  const t = useMemo(() => apiTestingTranslator(language), [language]);
  return { language, t, ...apiTestingFeedback(language) };
}
